<template>
  <div class="cols">
    <div class="table-wrapper">
      <DataGrid
          class="important-maintenance-grid"
          :data="items"
          :data-model="dataModel"
          :interactive="false"
      />
    </div>
    <div class="rows justify-end pt-10">
      <button type="button" @click="$emit('close')">{{ $t('generic.close') }}</button>
    </div>
  </div>
</template>

<script>
import DataGrid from "@/components/pages/partials/DataGrid.vue";

export default {
  name: "ImportantMaintenancesPopup",
  components: {DataGrid},
  emits: ['close'],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    dataModel() {
      return {
        headers: {
          [this.$t('maintenance.popup.vehicle-name')]: 'vehicleName',
          [this.$t('maintenance.popup.license-plate')]: 'licensePlate',
          [this.$t('maintenance.popup.status')]: 'status',
          [this.$t('maintenance.popup.maintenance-name')]: 'maintenanceName',
          [this.$t('maintenance.description')]: 'maintenanceDescription',
        },
        columnClasses: {
          status: 'status-column',
          maintenanceName: 'maintenance-name-column',
        },
      };
    }
  }
}
</script>

<style scoped lang="scss">

.table-wrapper {
  max-height: 420px;
  overflow-y: auto;
}

:deep(.important-maintenance-grid) {
  width: 100%;
  padding: 0;
  margin: 0;
}

:deep(.important-maintenance-grid .status-column) {
  min-width: 120px;
}

:deep(.important-maintenance-grid .maintenance-name-column) {
  width: 150px;
  min-width: 150px;
}
</style>
